export default __webpack_public_path__ + "static/media/LeadershipAward.ab12a1df.jpeg";